/**
 * Address validation utility functions
 * Centralized logic for address field conditional validation
 */

// Countries that have state/province fields
export const COUNTRIES_WITH_STATES = ['US', 'CA', 'MX'] as const;

// Countries that have county fields
export const COUNTRIES_WITH_COUNTIES = ['US'] as const;

/**
 * Determines if state field should be visible/required based on selected country
 * Used for both UI rendering and validation checks
 *
 * @param countryCode - The country code (e.g., 'US', 'CA', 'MX', 'PR')
 * @returns true if the country supports states and state field should be shown/validated
 *          If no country is selected (undefined/null), returns true to show state as required
 */
export const shouldShowStateForCountry = (countryCode: string | null | undefined): boolean => {
  // If no country selected yet, show state as required (default behavior)
  if (!countryCode) return true;
  // Otherwise, check if country is in the list that requires states
  return COUNTRIES_WITH_STATES.includes(countryCode as any);
};

/**
 * Determines if county field should be visible/required based on selected country
 * Used for both UI rendering and validation checks
 *
 * @param countryCode - The country code (e.g., 'US')
 * @returns true if the country supports counties and county field should be shown/validated
 */
export const shouldShowCountyForCountry = (countryCode: string | null | undefined): boolean => {
  if (!countryCode) return false;
  return COUNTRIES_WITH_COUNTIES.includes(countryCode as any);
};
